export const documentStatus = {
    InProcess: 1,
    RequiresRevision: 2,
    Success: 3
}